import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import clinicAPI from "../../../services/clinicApi";
import TrainerGroupSlotAssignment from "./TrainerGroupSlotAssignment";
import { HubSegment } from "../AdminPortal/HubPwa";
import { DOCTORS_BASE } from "./doctorConstants";
import s from "../clinic.module.css";
import aa from "../AdminPortal/adminApp.module.css";
import { EmptyState, Field, Select } from "../../ui";

export default function TrainerGroupSchedule({
  doctorId,
  trainerName,
  assignedGroups: assignedGroupsProp,
  onScheduleSaved,
  isPwa = false,
  onGoToAssignments,
}) {
  const navigate = useNavigate();
  const [groups, setGroups] = useState(assignedGroupsProp || []);
  const [activeGroupId, setActiveGroupId] = useState("");
  const [loading, setLoading] = useState(
    assignedGroupsProp == null && Boolean(doctorId),
  );

  useEffect(() => {
    if (assignedGroupsProp != null) {
      setGroups(assignedGroupsProp);
      setActiveGroupId((prev) => {
        if (prev && assignedGroupsProp.some((g) => g.id === prev)) return prev;
        return assignedGroupsProp[0]?.id || "";
      });
      setLoading(false);
      return;
    }
    if (!doctorId) {
      setGroups([]);
      setActiveGroupId("");
      setLoading(false);
      return;
    }
    setLoading(true);
    clinicAPI
      .getDoctor(doctorId)
      .then((r) => {
        const next = r.doctor?.groups || [];
        setGroups(next);
        setActiveGroupId((prev) => {
          if (prev && next.some((g) => g.id === prev)) return prev;
          return next[0]?.id || "";
        });
      })
      .catch(() => {
        setGroups([]);
        setActiveGroupId("");
      })
      .finally(() => setLoading(false));
  }, [doctorId, assignedGroupsProp]);

  const activeGroup = useMemo(
    () => groups.find((g) => g.id === activeGroupId) || null,
    [groups, activeGroupId],
  );

  const groupTabs = useMemo(
    () => groups.map((g) => ({ id: g.id, label: g.name })),
    [groups],
  );

  const assignmentsHref = `${DOCTORS_BASE}/${doctorId}?tab=assignments`;

  if (loading) {
    return (
      <p className={s.groupsHubScheduleHint}>Загрузка групп тренера…</p>
    );
  }

  if (!groups.length) {
    return (
      <EmptyState
        title="Нет групп"
        description="Назначьте тренера на группы — затем отметьте, какие слоты занятий он ведёт."
        actionLabel="Назначить группы"
        onAction={
          isPwa
            ? onGoToAssignments
            : () => navigate(assignmentsHref)
        }
      />
    );
  }

  return (
    <div className={s.trainerGroupSchedule}>
      {isPwa ? (
        <div className={aa.hubSegmentWrap}>
          <HubSegment
            tabs={groupTabs}
            active={activeGroupId}
            onChange={setActiveGroupId}
            scrollable
          />
        </div>
      ) : (
        <div className={s.scheduleBranchBar}>
          <Field label="Группа">
            <Select
              value={activeGroupId}
              onChange={(e) => setActiveGroupId(e.target.value)}
            >
              {groups.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.name}
                </option>
              ))}
            </Select>
          </Field>
        </div>
      )}

      {activeGroup && doctorId ? (
        <TrainerGroupSlotAssignment
          key={activeGroup.id}
          groupId={activeGroup.id}
          groupName={activeGroup.name}
          trainerId={doctorId}
          trainerName={trainerName || "Тренер"}
          onSaved={onScheduleSaved}
          isPwa={isPwa}
        />
      ) : null}
    </div>
  );
}
